import type { ReceivedInviteTone } from "../../utils/groupReceivedInvites";

/** Cor da borda lateral do card (chaves do tema, sem hex). */
export const INVITE_TONE_BORDER: Record<ReceivedInviteTone, string> = {
  now: "success.main",
  today: "primary.main",
  upcoming: "info.main",
  past: "divider",
  none: "divider",
};

/** Cor do marcador do grupo: `divider` some no fundo, então usa text.disabled. */
export const INVITE_TONE_DOT: Record<ReceivedInviteTone, string> = {
  ...INVITE_TONE_BORDER,
  past: "text.disabled",
  none: "text.disabled",
};
